function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.7071 7.29302L25.3432 0.929054C24.9526 0.53853 24.3195 0.53853 23.9289 0.929054C23.5384 1.31958 23.5384 1.95274 23.9289 2.34327L28.5858 7.00012L3.41423 7.00012L8.07108 2.34327C8.4616 1.95275 8.4616 1.31958 8.07108 0.929056C7.68056 0.538532 7.04739 0.538532 6.65687 0.929056L0.292906 7.29302C-0.0976181 7.68354 -0.0976181 8.31671 0.292906 8.70723L6.65687 15.0712C7.04739 15.4617 7.68056 15.4617 8.07108 15.0712C8.46161 14.6807 8.46161 14.0475 8.07108 13.657L3.41423 9.00012L28.5858 9.00012L23.9289 13.657C23.5384 14.0475 23.5384 14.6807 23.9289 15.0712C24.3195 15.4617 24.9526 15.4617 25.3432 15.0712L31.7071 8.70723C32.0976 8.3167 32.0976 7.68354 31.7071 7.29302Z"
});

function SvgArrowsConversion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 16,
    viewBox: "0 0 32 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsConversion);
export default __webpack_public_path__ + "static/media/ArrowsConversion.2de8d82d.svg";
export { ForwardRef as ReactComponent };